import { Box, Paper, Tab, Tabs, Typography } from "@mui/material";
import React from "react";

import { useMcsContext } from "./MCS.context";
import { useNavigate } from "react-router-dom";
import TabPanelFormat from "../../../../../components/widgets/TabPanelFormat";
import { getMCSTabs } from "./MCSTabs";
import {
  getHashdataUrl,
  setHashUrl,
} from "../../../../../components/Tabs/Utils/hashFunctions";

export default function Main() {
  const { mcsCurrentTab, setMcsCurrentTab, plant, mrqList } = useMcsContext();
  const navigate = useNavigate();
  const tabs = getMCSTabs(mrqList);
  const navLabel = "mcs-tab";

  // const fullHash = window.location.hash;
  // React.useEffect(() => {
  //   const hashValue = getHashdata(fullHash, navLabel);
  //   const tabIndex = tabs.findIndex(
  //     (tab) => tab.label === decodeURIComponent(hashValue)
  //   );

  //   // console.log({ tabIndex });
  //   // if hash value for tabs is present, set it as currentTab
  //   if (tabIndex !== -1) {
  //     setMcsCurrentTab(tabIndex);
  //   }
  //   // if its not present, but there is some existing hash value, add this to the hash value
  //   else if (fullHash)
  //     window.location.hash = fullHash + "&" + navLabel + "=" + tabs[0].label;
  //   // if not either, start a new hash
  //   else window.location.hash = navLabel + "=" + tabs[0].label;
  // }, []);

  React.useEffect(() => {
    const hashValue = getHashdataUrl(navLabel);

    const tabIndex = tabs.findIndex(
      (tab) => tab.label === decodeURIComponent(hashValue)
    );

    if (tabIndex !== -1) {
      setMcsCurrentTab(tabIndex);
    } else {
      setHashUrl(navLabel, tabs[0].label);
    }
  }, []);

  const handleChange = (_, newValue) => {
    setMcsCurrentTab(newValue);
    setHashUrl(navLabel, tabs[newValue].label);
  };

  // const handleChange = (event, newValue) => {
  //   // console.log("CHNGE");
  //   setMcsCurrentTab(newValue);

  //   setHash(fullHash, navLabel, tabs[newValue].label);
  // };

  return (
    <Paper sx={{ width: "100%", display: "flex" }}>
      <Box {...{ width: "100%", overflow: "auto" }}>
        <Tabs
          sx={{}}
          value={mcsCurrentTab}
          onChange={handleChange}
          orientation={"horizontal"}
        >
          {tabs.map((tab, i) => {
            return <Tab label={tab.label} value={i} />;
          })}

          {plant?.id && (
            <Typography
              variant="h6"
              color="secondary"
              m={"auto 10px"}
              sx={{
                position: "absolute",
                right: 30,
                top: "50%",
                transform: "translateY(-50%)",
              }}
            >
              <Typography variant="span" m={"auto 10px"} sx={{ color: "#444" }}>
                Main Project :
              </Typography>
              <span
                // style={{ textDecoration: "underline", cursor: "pointer" }}
                onClick={() => {
                  // navigate("/plant/" + plant?.id);
                }}
              >
                {plant?.name}
              </span>
            </Typography>
          )}
        </Tabs>

        <TabPanelFormat {...tabs[mcsCurrentTab].panelProps}>
          {tabs[mcsCurrentTab].panel}
        </TabPanelFormat>
      </Box>
    </Paper>
  );
}
